import { useEffect, useState } from "react";

/**
 * Detect if the app is in PWA mode : TWA, Chrome & Safari
 */
export const useIsPWA = () => {
    const [isPWAMode, setIsPWAMode] = useState(false);

    const isInStandaloneMode = () =>
        window.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as any).standalone ||
        document.referrer.includes("android-app://");

    useEffect(() => {
        setIsPWAMode(isInStandaloneMode());
    }, []);

    return isPWAMode;
};
